
import { Link } from 'gatsby';
import { useState } from 'react';
import React from 'react';
import { Box, Button, Flex } from 'theme-ui';

const NavButton = ({ onClick, className = '', disabled }) => (
  <Button
    className={`banner-slider-nav__button ${className}`}
    variant="empty"
    onClick={onClick}
    disabled={disabled}
  >
    <Box className="banner-slider-nav__button-dot" />
  </Button>
);

const bannerSliderNav = ({
  subjectInfo = {},
  onPrev,
  onNext,
  animationDuration,
}) => {
  const vm = {
    subjectTitle: subjectInfo.title,
    subjectLink: `/${subjectInfo.slug}`,
  };

  const [isMoving, setIsMoving] = useState(false);
  const [tackAnimateClass, setTackAnimateClass] = useState('');

  const onClickPrev = () => {
    animateNav(true, 'slide-top');

    onPrev();

    const timer = setTimeout(() => {
      clearTimeout(timer);
      animateNav(false);
    }, animationDuration);
  };

  const onClickNext = () => {
    animateNav(true, 'slide-down');

    onNext();

    const timer = setTimeout(() => {
      clearTimeout(timer);
      animateNav(false);
    }, animationDuration);
  };

  const animateNav = (isMoving, animateClass = '') => {
    setIsMoving(isMoving);
    setTackAnimateClass(animateClass);
  };

  return (
    <Flex
      className="banner-slider-nav"
      px={4}
      sx={{
        display: ['none', null, null, 'flex'],
      }}
    >
      <Flex className={`banner-slider-nav__subject ${tackAnimateClass}`}>
        <Link sx={{ marginTop: 'auto', color: 'white' }} to={vm.subjectLink}>
          {vm.subjectTitle}
        </Link>
      </Flex>

      <Box sx={{ overflow: 'hidden', height: '200px' }}>
        <Box className={`banner-slider-nav__track ${tackAnimateClass}`}>
          <NavButton disabled={isMoving} onClick={onClickPrev} />
          <NavButton disabled={isMoving} onClick={onClickPrev} />
          <NavButton disabled={isMoving} onClick={onClickPrev} />
          <NavButton
            className={!isMoving && 'banner-slider-nav__button--active'}
          />
          <NavButton disabled={isMoving} onClick={onClickNext} />
          <NavButton disabled={isMoving} onClick={onClickNext} />
          <NavButton disabled={isMoving} onClick={onClickNext} />
        </Box>
      </Box>
    </Flex>
  );
};

export default bannerSliderNav;
